import React from 'react';

// Material UI
import { styled, Box, Button, CircularProgress, Typography } from '@material-ui/core';

// Components
import DiscountForm from 'components/DiscountForm';
import OrderReceipt from 'components/OrderReceipt';

// Utility
import { Trans, t } from '@lingui/macro';
import { useCheckoutContext } from 'context/CheckoutContext';

export default function OrderSummary() {
    const {
        event,
        paidTransaction,
        discountFormState,
        handleDiscountChange: onDiscountChange,
        handleDiscountSubmit: onDiscountSubmit,
        handleDiscountDelete: onDiscountDelete,
        handleFormSubmit: onClick,
        disablePurchase,
        errorMessage,
        showDiscountForm,
        products,
        bundles,
        discount,
    } = useCheckoutContext();

    return (
        <div>
            <h3>
                <Trans>Order Summary</Trans>
            </h3>

            {showDiscountForm && (
                <DiscountForm
                    code={discountFormState.code}
                    status={discountFormState.status}
                    message={discountFormState.message}
                    onChange={onDiscountChange}
                    onDelete={onDiscountDelete}
                    onSubmit={onDiscountSubmit}
                />
            )}

            <OrderReceipt
                products={products}
                bundles={bundles}
                event={event}
                paidTransaction={paidTransaction}
                discount={discount}
                discountCode={discountFormState.code}
            />

            <Box textAlign="center" mt="1rem" mb="1rem">
                <Trans>Please note: All purchases are final, and refunds are not available.</Trans>
            </Box>

            {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
            <Box display="flex" justifyContent="center" width={1} mt="1rem" mb="1rem">
                <PurchaseButton variant="contained" onClick={onClick} disabled={disablePurchase}>
                    {disablePurchase ? <PurchaseSpinner size={24} /> : t`Complete Your Order`}
                </PurchaseButton>
            </Box>
        </div>
    );
}

const PurchaseButton = styled(Button)(({ theme }) => ({
    width: '75%',
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
        backgroundColor: theme.palette.primary.main,
    },
}));

const PurchaseSpinner = styled(CircularProgress)(({ theme }) => ({
    color: theme.palette.primary.main,
}));

const ErrorMessage = styled(Typography)(({ theme }) => ({
    color: theme.palette.error.main,
    textAlign: 'center',
}));
